import React from "react";
import ReactDOM from "react-dom";
import App from './components/App/App.jsx';
import WindowContext from './containers/WindowContext/WindowContext.jsx';
import "../sass/main.scss";
import $ from 'jquery';
import Materialize from 'materialize-css';
import touchAction from 'touch-action'



touchAction();

/*materialize('.parallax').parallax();*/
/*$(function(){
    //console.log("AM HEREERERERE");
    $('.button-collapse').sideNav();
    //$('.parallax').parallax();   
});*/

$(function(){
    //$('.button-collapse').sideNav();
    //$('.parallax').parallax();   
});

ReactDOM.render(
    <WindowContext><App /></WindowContext>,
    document.getElementById('reactmount')
);




// WEBPACK FOOTER //
// ./src/js/app.jsx